import { render, staticRenderFns } from "./ALanding.vue?vue&type=template&id=098d03dc&scoped=true&"
import script from "./ALanding.vue?vue&type=script&lang=js&"
export * from "./ALanding.vue?vue&type=script&lang=js&"
import style0 from "./ALanding.vue?vue&type=style&index=0&id=098d03dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098d03dc",
  null
  
)

export default component.exports